import type { Theme, ThemePresets } from '../types';

import getGeneratedTheme from './getGeneratedTheme';
import resolveComponentsTheme from './resolvers/resolveComponentsTheme';
import resolveCoreTheme from './resolvers/resolveCoreTheme';
import resolveSemanticTheme from './resolvers/resolveSemanticTheme';
import { ThemeOverrides } from './types';

type Options = {
  /** defines which of the available presets should be used as baseline */
  preset?: ThemePresets;
  overrides?: ThemeOverrides;
};

/**
 * Generates theme by merging it with default one
 *
 * @note
 * The returned theme has resolved values (aka it doesn't have aliases in field values),
 * and is mapped to the FE model
 */
const createTheme = (options?: Options): Theme => {
  const { preset = 'humm', overrides = {} } = options || {};

  const generatedTheme = getGeneratedTheme(preset);

  const core = resolveCoreTheme({ generatedTheme, overrides });

  const semantic = resolveSemanticTheme({ generatedTheme, core, overrides });

  const components = resolveComponentsTheme({
    generatedTheme,
    core,
    semantic,
    overrides,
  });

  return {
    core,
    semantic,
    components,
  };
};

export default createTheme;
